import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormKeys } from '@nx-customer-apps/shared/enums';
import { FormOptions, RadioQuestionOverride } from '@nx-customer-apps/shared/interfaces';
import { RadioQuestion } from '@nx-customer-apps/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class EnergyStandardFormService {
    constructor() {}

    public getEnergyStandardQuestions(options?: FormOptions): [RadioQuestion] {
        const energyStandardOverride = options?.questions?.[FormKeys.EnergyStandards];
        return this.getEnergyStandard(energyStandardOverride as RadioQuestionOverride);
    }

    private getEnergyStandard(override?: RadioQuestionOverride): [RadioQuestion] {
        const options = override?.options.map(standard => ({
            key: `COMMON.ENERGY_STANDARDS.${standard.countryCode}.${standard.key}`,
            value: standard,
            id: standard.key
        }));

        const isOnlyOneOptionToSelect = override?.options.length === 1;
        let value = isOnlyOneOptionToSelect ? override?.options[0] : '';
        if (override?.value) {
            value = override.value;
        }

        return [
            new RadioQuestion({
                question: 'HEATLOAD.ENERGY_STANDARD.ENERGY_STANDARDS.TITLE',
                key: FormKeys.EnergyStandards,
                styles: 'ca-radio-columns',
                defaultErrorMessage: 'HEATLOAD.ENERGY_STANDARD.ENERGY_STANDARDS.ERRORS.REQUIRED',
                validators: [Validators.required],
                options,
                value: value || '',
                hidden: isOnlyOneOptionToSelect
            })
        ];
    }
}
